import React from 'react'
import moment from 'moment'

// graphql
import { useQuery } from '@apollo/client'
import { GET_JOB_BY_ID_WITH_INFO } from '../../../../../graphql/job/job.queries'

// components
import Card from '../../../../../components/cards/Card/Card.component'
import CardDataPoint from '../../../../../components/cards/CardDataPoint/CardDataPoint.component'

export default function JobInfo({ jobId }) {

    const { data } = useQuery(GET_JOB_BY_ID_WITH_INFO, {
        variables: { id: jobId }
    })

    let job = {}

    if(data && data.jobLite) {
        job = {...data.jobLite}
    }

    // // temporary data
    // const job = {
    //     id: 1,
    //     street1: "1234 Somewhere St.",
    //     city: "Ontario",
    //     state: "CA",
    //     zipcode: "91761",
    //     estimatedStartDate: "1/1/2023"
    // }

    return (<Card header={{ icon: null, title: 'Info'}}>
        
        <CardDataPoint label='Number' value={job.id} />
        <CardDataPoint label='Address' value={job.street1 ? [`${job.street1}`, `${job.city}${job.state ? ',' : ''} ${job.state} ${job.zipcode}`] : null} />
        <CardDataPoint label='Estimated Start Date' value={moment(job.estimatedStartDate).isValid() ? moment(job.estimatedStartDate).format("MM/DD/YYYY") : null} />

    </Card>)
}